(function () {
  class ProductSlider {
    constructor(el) {
      this.el = el;
      this.track = el.querySelector('.serotonProductSlider__track');
      if (!this.track) return;

      this.prevBtns = el.querySelectorAll('.serotonProductSlider__navBtn--prev');
      this.nextBtns = el.querySelectorAll('.serotonProductSlider__navBtn--next');

      this.prevBtns.forEach(btn => btn.addEventListener('click', () => this.scroll(-1)));
      this.nextBtns.forEach(btn => btn.addEventListener('click', () => this.scroll(1)));

      this.track.addEventListener('scroll', () => this.updateActive(), { passive: true });

      this.updateActive();
    }

    _getStep() {
      const card = this.track.querySelector('.serotonProductSlider__card');
      if (!card) return 0;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return card.offsetWidth + gap;
    }

    scroll(dir) {
      const step = this._getStep();
      if (!step) return;
      this.track.scrollBy({ left: dir * step, behavior: 'smooth' });
    }

    updateActive() {
      const cards = Array.from(this.track.querySelectorAll('.serotonProductSlider__card'));
      const trackLeft = this.track.getBoundingClientRect().left;

      let closestCard = cards[0];
      let minDiff = Infinity;

      cards.forEach(card => {
        const diff = Math.abs(card.getBoundingClientRect().left - trackLeft);
        if (diff < minDiff) {
          minDiff = diff;
          closestCard = card;
        }
      });

      cards.forEach(c => c.classList.remove('serotonProductSlider__card--active'));
      if (closestCard) closestCard.classList.add('serotonProductSlider__card--active');
    }
  }

  function init() {
    document.querySelectorAll('.serotonProductSlider').forEach(el => new ProductSlider(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();